<template>
  <b-container>
    <div class="promocodes-heading">
      <h2>Promocodes</h2>

      <div class="pr-btn-container">
        <v-btn color="primary" dark @click="openForm"> Create Promocode </v-btn>
        <PromocodeModal
          v-model="formData"
          :toggleForm="toggleForm"
          :editingPromocode="editingPromocode"
          @updatePromotionalCodes="updatePromotionalCodes"
          @closeEditing="closeEditing"
          @closeForm="closeForm"
        />
        <PromoCodePopup
          :isOn="promoCodePopup.isOn"
          v-model="promoCodePopup.promoCode"
          @promoCodePopupOff="promoCodePopupOff"
        />
      </div>
    </div>
    <hr />

    <v-data-table
      :headers="headers"
      :items="promocodes"
      item-class="table-rows"
      class="elevation-1 pr-t-class"
      :loading="codesLoading"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.action`]="{ item }">
        <b-link v-if="item.isActive" @click="disableCode(item)">Disable</b-link>
        <b-link v-if="!item.isActive" @click="enableCode(item)">Enable</b-link>
        / <b-link @click="editPromocodeClicked(item)">Edit</b-link>
      </template>
    </v-data-table>
  </b-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import {
  enablePromoCode,
  disablePromoCode
} from "../../../../graphql/mutations";
import PromocodeModal from "@/components/promocode/PromocodeModal.vue";
import PromoCodePopup from "@/components/promocode/PromoCodePopup.vue";
import PromocodePermissionsMixin from "@/components/promocode/PromocodePermissionsMixin.js";
import { getPromoCodeById } from "../../../../graphql/queries";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  mixins: [PromocodePermissionsMixin],
  components: { PromocodeModal, PromoCodePopup },
  data() {
    return {
      codesLoading: false,
      headers: [
        { text: "Code", align: "start", value: "code" },
        { text: "Name", value: "name" },
        { text: "Active", value: "isActive" },
        { text: "Created By", value: "createdBy" },
        { text: "Description", value: "description" },
        { text: "Action", value: "action" }
      ],
      promoCodePopup: {
        isOn: false,
        promoCode: {
          id: "",
          description: "",
          name: "",
          code: "",
          uses: 0,
          isActive: false,
          discount: { isAvailable: false, amount: 0, type: "" },
          requirements: {
            isAvailable: false,
            startDate: null,
            endDate: null,
            customerEmail: null
          },
          recurring: {
            isAvailable: false,
            discount: { isAvailable: false, amount: 0, type: "" },
            freeTrials: null
          },
          createdBy: ""
        }
      },
      promocodes: [],
      toggleForm: false,
      editingPromocode: false,
      formData: {
        general: {
          name: "",
          code: "",
          description: ""
        },
        discount: {
          isAvailable: false,
          amount: 0,
          type: "Fixed"
        },
        requirements: {
          isAvailable: false,
          startDate: new Date(),
          endDate: new Date(),
          customerEmail: ""
        },
        recurring: {
          isAvailable: false,
          discount: {
            isAvailable: false,
            amount: 0,
            type: "Fixed"
          },
          freeTrials: []
        }
      }
    };
  },
  methods: {
    async getProtionalCodes() {
      try {
        this.codesLoading = true;
        const result = await API.graphql(
          graphqlOperation(`
          query ListPromotionalCodes {
  listPromotionalCodes {
    error
    success
    promotionalCodes {
      id
      description
      name
      code
      uses
      isActive
      discount {
        isAvailable
        amount
        type
      }
      requirements {
        isAvailable
        startDate
        endDate
        customerEmail
      }
      recurring {
        isAvailable

        freeTrials {
          frequency
          period
        }
      }
      createdBy
    }
    nextToken
  }
}

                `)
        );
        this.codesLoading = false;
        return result.data.listPromotionalCodes.promotionalCodes;
      } catch (error) {
        this.codesLoading = false;
        this.$logger.error(error);
      }
    },
    async enableCode(code) {
      if (!this.canEditOrCreatePromocodes) {
        this.createToast("danger", "Not allowed to Edit Promocode");
        return;
      }
      try {
        const { data } = await API.graphql({
          ...graphqlOperation(enablePromoCode, { id: code.id })
        });

        if (!data.enablePromoCode.success) {
          throw new Error("Something went wrong enabling code.");
        }

        this.createToast("success", "Promo Code enabled successfully");
        this.updatePromotionalCodes();
      } catch (error) {
        this.$logger.error(error);
        this.createToast("danger", "Something went wrong enabling code");
      }
    },
    async disableCode(code) {
      if (!this.canDeletePromocodes) {
        this.createToast("danger", "Not allowed to Disable Promocode");
        return;
      }
      try {
        const { data } = await API.graphql({
          ...graphqlOperation(disablePromoCode, { id: code.id })
        });

        if (!data.disablePromoCode.success) {
          throw new Error("Something went wrong disabling code.");
        }

        this.createToast("success", "Promo Code disabled successfully");
        this.updatePromotionalCodes();
      } catch (error) {
        this.$logger.error(error);
        this.createToast("danger", "Something went wrong disabling code");
      }
    },

    createToast(variant, message) {
      this.$bvToast.toast(message, {
        title: "Promo Code Settings",
        autoHideDelay: 5000,
        variant,
        append: true
      });
    },
    editPromocodeClicked(data) {
      if (!this.canEditOrCreatePromocodes) {
        this.createToast("danger", "Not allowed to Edit Promocode");
        return;
      }
      this.editingPromocode = true;
      this.toggleForm = true;
      this.formData = {
        ...this.parsePromoDataToForm(data)
      };
    },
    parsePromoDataToForm(data) {
      const transformedData = {
        general: {
          name: data.name,
          code: data.code,
          description: data.description,
          id: data.id
        },
        discount: {
          isAvailable: data.discount.isAvailable,
          amount: data.discount.amount,
          type: data.discount.type || "Fixed"
        },
        requirements: {
          isAvailable: data.requirements.isAvailable,
          startDate: data.requirements.startDate || new Date(),
          endDate: data.requirements.endDate || new Date(),
          customerEmail: data.requirements.customerEmail || ""
        },
        recurring: {
          isAvailable: data.recurring.isAvailable,
          discount: {
            isAvailable: data.discount.isAvailable,
            amount: data.discount.amount,
            type: data.discount.type || "Fixed"
          },
          freeTrials: data.recurring.freeTrials || [
            { frequency: "Daily", period: 1 }
          ]
        }
      };

      return transformedData;
    },
    openForm() {
      if (!this.canEditOrCreatePromocodes) {
        this.createToast("danger", "Not allowed to Edit or Create Promocode");
        return;
      }
      this.toggleForm = true;
    },
    closeForm() {
      this.toggleForm = false;
    },
    closeEditing() {
      this.editingPromocode = false;
    },
    promoCodePopupOff() {
      this.promoCodePopup.isOn = false;
      this.promoCodePopup.promoCode = {
        id: "",
        description: "",
        name: "",
        code: "",
        uses: 0,
        isActive: false,
        discount: { isAvailable: false, amount: 0, type: "" },
        requirements: {
          isAvailable: false,
          startDate: null,
          endDate: null,
          customerEmail: null
        },
        recurring: {
          isAvailable: false,
          discount: { isAvailable: false, amount: 0, type: "" },
          freeTrials: null
        },
        createdBy: ""
      };
    },
    async findPromocode(id) {
      const result = await API.graphql(
        graphqlOperation(getPromoCodeById, { id: id })
      );
      return result.data.getPromoCodeById.promotionalCode;
    },

    async updatePromotionalCodes() {
      this.promocodes = await this.getProtionalCodes();
    },
    async displayPromocode(paramPromocodeId) {
      if (typeof paramPromocodeId === "undefined") return;

      const promoCode = await this.findPromocode(paramPromocodeId);

      if (!promoCode) {
        this.createToast("danger", "PromoCode not found");
        return;
      }

      this.promoCodePopup = { isOn: true, promoCode: promoCode };
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Promocodes" }]);
    await this.updatePromotionalCodes();
    const paramPromocodeId = this.$route.params.promocodeid;
    await this.displayPromocode(paramPromocodeId);
  }
};
</script>
<style>
.promocodes-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
}
.promocode-btn {
  height: 40px;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  padding: 0 10px;
  border-radius: 6px;
}
</style>
